import { EntityRootData, UserInfo } from '@web-config-app/core';

/**
 * Adds a meta field to the body data.
 *
 * @param bodyData - The body data to add the meta field to.
 * @param userInfo - The user info to add to the meta field.
 * @returns The body data with the meta field added.
 */
export const addMetaFieldToBodyData = (
  bodyData: EntityRootData,
  userInfo: UserInfo,
) => ({
  ...bodyData,
  meta: {
    author: userInfo,
  },
});
